import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaLinkedinIn, FaYoutube, FaChevronUp } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { services } from "../data";

function Footer() {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 400) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, [showScroll]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Split services into two columns
  const midIndex = Math.ceil(services.length / 2);
  const servicesCol1 = services.slice(0, midIndex);
  const servicesCol2 = services.slice(midIndex);

  return (
    <footer className="footer-enhanced">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Column 1: Brand & Social */}
          <div className="footer-brand-col">
            <div className="footer-logo">
              <img src="/logo.png" alt="Cabptoid" />
              <div className="brand-wordmark">
                <span className="brand-main">Cabptoid</span>
                <span className="brand-sub">SOLUTIONS</span>
              </div>
            </div>
            <div className="social-links-footer">
              <a href="https://www.facebook.com/profile.php?id=61587480283303" target="_blank" rel="noreferrer"><FaFacebookF /></a>
              <a href="https://x.com/cabptoid91649" target="_blank" rel="noreferrer"><FaXTwitter /></a>
              <a href="https://www.linkedin.com/company/cabptoid-solutions" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
              <a href="https://www.youtube.com/channel/UC7jqBIA3cJMcuOq2JgSyksQ" target="_blank" rel="noreferrer"><FaYoutube /></a>
            </div>
            <div className="dmca-badge">
              <img src="https://images.dmca.com/Badges/dmca_protected_sml_120n.png?ID=ed546452-f67f-432a-b605-83e911225895" alt="DMCA.com Protection Status" />
            </div>
          </div>

          {/* Column 2: Contacts */}
          <div className="footer-contact-col">
            <h3>Contacts</h3>
            <div className="contact-item-footer">
              <p>2nd floor,</p>
              <p>Aikya Vihar, Kavuri Hills,</p>
              <p>Hyderabad, Telangana</p>
              <p>500033</p>
            </div>
            <div className="contact-item-footer phones">
              <p>+91 63047 65654</p>
            </div>
            <div className="contact-item-footer email">
              <a href="mailto:vinushna.lakkakula@cabptoidsolutions.com">vinushna.lakkakula@cabptoidsolutions.com</a>
            </div>
            <div className="contact-item-footer linkedin">
              <p className="poc-label">Point of Contact:</p>
              <a href="https://www.linkedin.com/in/vinushnalakkakula/" target="_blank" rel="noreferrer">
                Vinushna Lakkakula <FaLinkedinIn style={{ fontSize: '14px', marginLeft: '5px' }} />
              </a>
            </div>
          </div>

          {/* Column 3: Services 1 */}
          <div className="footer-links-col">
            <h3>Services</h3>
            <ul>
              {servicesCol1.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`}>{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Services 2 */}
          <div className="footer-links-col">
            <h3 className="empty-h3">&nbsp;</h3>
            <ul>
              {servicesCol2.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`}>{s.title}</Link>
                </li>
              ))}
              <li><Link to="/portfolio">Success Stories</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom-enhanced">
          <p>© 2017 Cabptiod Solutions. All rights reserved.</p>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <AnimatePresence>
        {showScroll && (
          <motion.button
            className="scroll-top-btn"
            onClick={scrollToTop}
            initial={{ opacity: 0, scale: 0.5, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.5, y: 20 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FaChevronUp />
          </motion.button>
        )}
      </AnimatePresence>
    </footer>
  );
}

export default Footer;